import Skeleton from '@material-ui/lab/Skeleton';
import React from 'react';

import styles from './SkeletonEventInfoWidget.scss';

const SkeletonEventInfoWidget: React.FC = () => (
  <div className={styles.widgetRow}>
    <Skeleton variant="rect" height="30px" width="300px" animation="pulse" />
    <Skeleton variant="rect" height="21px" width="180px" animation="pulse" />
  </div>
);

export default SkeletonEventInfoWidget;
